import { useState } from "react";

import { useUser } from "@components/user-context";
import { type PasswordResetResponse } from "@north-beam/nb-common";
import { PrimaryButton, SecondaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

function ResetPassword() {
  const { user } = useUser();

  const [passwordResetDisabled, setPasswordResetDisabled] = useState(false);
  const [passwordResetEmailAddress, setPasswordResetEmailAddress] =
    useState("");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const resetPassword = async () => {
    setPasswordResetDisabled(true);
    const result = await user.callApi<PasswordResetResponse>(
      "/api/user/reset-my-password",
      {
        method: "POST",
      },
    );
    setPasswordResetEmailAddress(result.auth0Email);
  };

  const passwordResetLoading =
    passwordResetDisabled && !passwordResetEmailAddress;

  return (
    <>
      <h3 className="mt-4">
        <b>Password Reset</b>
      </h3>
      <div>
        Click here to reset your password. You will receive an email with
        instructions to create a new password.
      </div>
      <Modal
        isOpen={isConfirmModalOpen}
        titleContent={<div className="font-bold">Confirm Reset Password</div>}
        onClose={() => setIsConfirmModalOpen(false)}
      >
        <p className="py-4">
          Are you sure you would like to reset your password?
        </p>
        <div className="flex items-center justify-end gap-2">
          <PrimaryButton
            className="bg-mars hover:bg-mars+1"
            onClick={() => {
              setIsConfirmModalOpen(false);
              resetPassword();
            }}
          >
            CONFIRM
          </PrimaryButton>
          <SecondaryButton onClick={() => setIsConfirmModalOpen(false)}>
            CANCEL
          </SecondaryButton>
        </div>
      </Modal>
      <PrimaryButton
        onClick={() => setIsConfirmModalOpen(true)}
        className="font-bold mt-2"
        loading={passwordResetLoading}
      >
        RESET PASSWORD
      </PrimaryButton>
      <p hidden={!passwordResetEmailAddress}>
        An email has been sent to {passwordResetEmailAddress}.
      </p>
    </>
  );
}

export const UserSettings = () => {
  return (
    <div className="container pt-4">
      <h1 className="heading mx-0 mb-0 mt-0">User settings</h1>
      <hr />
      <ResetPassword />
    </div>
  );
};
